(function(){
  const cartIcon=document.querySelector('.cart-icon[href="/cart"]');
  const drawer=document.querySelector('.cd-main-d5');
  if(!cartIcon||!drawer)return;

  function positionDrawer(){
    const rect=cartIcon.getBoundingClientRect();
    const gap=12;
    const top=Math.max(rect.bottom+gap,0);
    const right=Math.max(window.innerWidth-rect.right,16);
    drawer.style.top=top+'px';
    drawer.style.right=right+'px';
    drawer.style.maxHeight='calc(100vh - '+top+'px - 20px)';
  }

  positionDrawer();
  window.addEventListener('resize',positionDrawer);

  // Lock background page scroll while any D5 modal/sheet is open - none of
  // these open/close paths touched document.body before, so the page
  // behind an open "Added to Bag" panel (or any other modal here) could
  // still be scrolled through it. A MutationObserver watching each modal's
  // own class list (rather than hooking every individual open/close call
  // site across this file) means this can't get out of sync with any of
  // them, and correctly keeps scroll locked as long as ANY one of several
  // possibly-stacked modals (e.g. Quick Add opened on top of Added to Bag)
  // is still active.
  (function () {
    const modalSelectors = ['.cn-main-d5', '.cd-main-d5', '.quick-add-modal-d5', '.cd-variant-update-modal-d5'];
    function anyModalActive() {
      return modalSelectors.some(function (sel) {
        const el = document.querySelector(sel);
        return el && el.classList.contains('active');
      });
    }
    function updateBodyScrollLock() {
      // A pre-existing sitewide rule sets overflow-y specifically (with
      // higher priority than a plain inline style can beat) - a plain
      // `document.body.style.overflow = 'hidden'` silently only wins the
      // x-axis, leaving vertical background scroll unlocked, exactly the
      // bug reported. setProperty(..., 'important') forces both axes on
      // both html and body, since some browsers scroll the root element
      // instead of body depending on the page's own overflow setup.
      const locked = anyModalActive();
      [document.documentElement, document.body].forEach(function (el) {
        if (locked) {
          el.style.setProperty('overflow', 'hidden', 'important');
        } else {
          el.style.removeProperty('overflow');
        }
      });
    }
    const observer = new MutationObserver(updateBodyScrollLock);
    modalSelectors.forEach(function (sel) {
      const el = document.querySelector(sel);
      if (el) observer.observe(el, { attributes: true, attributeFilter: ['class'] });
    });
    updateBodyScrollLock();
  })();

  if(window.innerWidth >= 750){
    cartIcon.addEventListener('mouseenter', () => {
        positionDrawer();
        drawer.classList.add('active');
    });

    // cartIcon.addEventListener('mouseleave', () => {
    //     drawer.classList.remove('active');
    // });

}
  document.addEventListener('click',e=>{
    const isClickInsideDrawer=drawer.contains(e.target);
    const isClickOnCartIcon=cartIcon.contains(e.target);
    if(!isClickInsideDrawer&&!isClickOnCartIcon&&drawer.classList.contains('active')){
      drawer.classList.remove('active');
    }
  });

  // Automatic "Often bought together" - uses Shopify's own product
  // recommendation engine (real order-history-based ML, not a manual list)
  // instead of the old fixed section.settings.upsell product picker. Tries
  // "complementary" (frequently-bought-together) first, falls back to
  // "related" (same category) if Shopify has no complementary data for this
  // product yet, and if neither returns anything just leaves whatever was
  // already showing (the merchant-curated static list on first load, or the
  // previous product's recommendations) rather than showing an empty state.
  async function fetchUpsellSection(productId, intent) {
    try {
      const res = await fetch(`/recommendations/products.json?product_id=${productId}&section_id=d5-cart-upsell-rec&intent=${intent}&limit=6`);
      if (!res.ok) return null;
      const data = await res.json();
      const html = data && data.sections && data.sections['d5-cart-upsell-rec'];
      if (!html) return null;
      const temp = document.createElement('div');
      temp.innerHTML = html;
      const newCon = temp.querySelector('.cn-upsell-con-d5');
      if (newCon && newCon.children.length > 0) return newCon;
      return null;
    } catch (err) {
      console.error('Error loading ' + intent + ' recommendations:', err);
      return null;
    }
  }

  async function loadUpsellRecommendations(productId) {
    const container = document.querySelector('#cart-notification-d5 .cn-upsell-con-d5');
    if (!container || !productId) return;
    let newCon = await fetchUpsellSection(productId, 'complementary');
    if (!newCon) newCon = await fetchUpsellSection(productId, 'related');
    if (newCon) container.innerHTML = newCon.innerHTML;
  }

 window.rerender = async function (addedKey = null) {
  const res = await fetch('/?section_id=d5-cart-drawer');
  const text = await res.text();
  const parser = new DOMParser();
  const doc = parser.parseFromString(text, 'text/html');
  const newElems = doc.querySelectorAll('[render-d5]');
  const currentElems = document.querySelectorAll('[render-d5]');
  const oldCount = document.querySelector('.cart-count-d5');
  const newCount = doc.querySelector('.cart-count-d5');
  if(oldCount && newCount){
    oldCount.innerHTML = newCount.innerHTML;
  }
  currentElems.forEach((el, i) => {
    const newEl = newElems[i];
    if (newEl) el.innerHTML = newEl.innerHTML;
  });
  drawer?.classList.remove('atc-loading-d5');
  if (window.innerWidth < 750 && addedKey) {
    const newItem = doc.querySelector(`[id="${addedKey}"]`);
    if (newItem) {
      const notifContainer = document.querySelector('.cart-notification-d5 .cn-items-d5');
      notifContainer.innerHTML = newItem.outerHTML;
      const notification = document.querySelector('.cn-main-d5');
      notification.classList.add('active');
      const productId = newItem.getAttribute('data-product-id');
      // Hide "Often bought together" until its final content is decided
      // (real recommendations or the static fallback), then fade it in
      // once - avoids showing the static list first and then silently
      // swapping it out a moment later while the shopper is looking at it.
      const upsellsSection = document.querySelector('#cart-notification-d5 .cn-upsells-d5');
      if (upsellsSection) upsellsSection.classList.remove('loaded');
      if (productId) await loadUpsellRecommendations(productId);
      if (upsellsSection) upsellsSection.classList.add('loaded');
    }
  }
};

document.querySelectorAll('form[action="/cart/add"]').forEach((form) => {
  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const btn = form.querySelector('.add_to_cart');

    if(btn) btn.textContent = 'Adding...'
    const isDesktop = window.innerWidth >= 750;

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(form),
      });
      const added = await res.json();
      await rerender(added.key);
      if(btn) btn.textContent = 'Add to Bag'
      if (isDesktop && drawer) {
        positionDrawer();
        drawer.classList.add('active');
      }
    } catch (err) {
      console.error(err);
    }
  });
});

  // const quickAds = document.querySelectorAll('.openCartBtn');
  // quickAds.forEach(q => {
  //   q.addEventListener('click', async () => {
  //     drawer.classList.add('atc-loading-d5');
  //     setTimeout(() => {
  //       drawer.classList.add('active');
  //     }, 200);
  //       await rerender();
  //   })
  // })
  document.addEventListener('click',async e=>{
    const minus=e.target.closest('.cd-qty-minus-d5');
    const plus=e.target.closest('.cd-qty-plus-d5');
    if(!minus&&!plus)return;
    e.preventDefault();
    const item=e.target.closest('[line-item]');
    if(!item)return;
    const key=item.getAttribute('line-item');
    const input=item.querySelector('.cd-qty-input-d5');
    let qty=parseInt(input.value,10);
    if(plus)qty++;
    if(minus)qty--;
    if(qty<1)qty=0;
    item.classList.add('loading');
    if (drawer) drawer.classList.add('cart-busy-d5');
    await fetch('/cart/change.js',{
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body:JSON.stringify({id:key,quantity:qty})
    });
    await rerender();
    if (drawer) drawer.classList.remove('cart-busy-d5');
  });

  document.body.addEventListener('click', async function (e) {
    const saveBtn = e.target.closest('.cd-save-later-d5');
    if (!saveBtn) return;
    e.preventDefault();
    const item = saveBtn.closest('[line-item]');
    if (!item) return;
    const key = item.getAttribute('line-item');
    saveBtn.classList.add('loading');
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      });
      await rerender();
    } catch (err) {
      console.error(err);
      saveBtn.classList.remove('loading');
    }
  });

  let oldVariantQuantity;
  let oldVariantId;
  document.body.addEventListener('click', async function (e) {
  const trigger = e.target.closest('.cd-item-options-d5')
  if (!trigger) return
  e.preventDefault()
  oldVariantId = trigger.getAttribute('variant-id');
  oldVariantQuantity = trigger.getAttribute('data-quantity');
  const modal = document.querySelector('.cd-variant-update-modal-d5')
  const modalInner = modal.querySelector('.cdv-um-inner-d5')
  const url = trigger.dataset.url
  // BUG FIX (animation): `.active` (which triggers the slide-up transition)
  // used to be added HERE, before the product content was fetched - so the
  // sheet slid up empty and the real size/color options popped in a moment
  // later. Matches the same fix already proven for the Quick Add modal:
  // only reveal the sheet once its real content is already in place.
  try {
    const response = await fetch(url)
    const html = await response.text()
    const temp = document.createElement('div')
    temp.innerHTML = html
    const mainProduct = temp.querySelector('.main-product-d5')
    temp.querySelector('.mp-update-btn-d5').classList.add('disabled');
    modal.classList.add('loading-nul');
    // BUG FIX: without this, opening "Edit Style" for a second item before
    // the modal's own content from a previous open was cleared left TWO
    // .main-product-d5 blocks side-by-side in this flex container, each
    // squeezed to half width. Same proven pattern already used by the
    // color-switch handler elsewhere in this file.
    const oldMainProduct = modalInner.querySelector('.main-product-d5');
    if (oldMainProduct) oldMainProduct.remove();
    if (mainProduct) modalInner.appendChild(mainProduct)
    modal.classList.add('active')
  } catch (error) {
    console.error('Error loading variant options:', error)
  }
  document.querySelectorAll('.wishlist-button-d5').forEach(button => {
              updateWishlistState(button);
            });
})

  document.body.addEventListener("click",function(e){
    const valueEl=e.target.closest(".mp-value-d5");
    if(!valueEl)return;
    const optionWrapper=valueEl.closest(".mp-option-values-d5");
    if(!optionWrapper)return;
    optionWrapper.querySelectorAll(".mp-value-d5").forEach(el=>el.classList.remove("active"));
    valueEl.classList.add("active");
    document.querySelector('.mp-update-btn-d5').classList.add('disabled');
    const productEl=document.querySelector(".mp-product-json-d5");
    if(!productEl)return;
    const productJson=JSON.parse(productEl.textContent);
    const selectedOptions=[];
    document.querySelectorAll(".mp-option-values-d5").forEach(group=>{
      const active=group.querySelector(".mp-value-d5.active");
      if(active)selectedOptions.push(active.textContent.trim());
    });
    const matchedVariant=productJson.variants.find(v=>v.options.every((opt,i)=>opt===selectedOptions[i]));
    if(matchedVariant){
      const mainProduct=document.querySelector(".main-product-d5");
      if(mainProduct){
        const url=mainProduct.getAttribute("data-url");
        fetch(`${url}&variant=${matchedVariant.id}`)
        .then(res=>res.text())
        .then(html=>{
          const temp=document.createElement("div");
          temp.innerHTML=html;
          const newInfo=temp.querySelector(".mp-product-info-d5");
          const oldInfo=document.querySelector(".mp-product-info-d5");
          const btn = temp.querySelector('.mp-update-btn-d5')
          if(oldVariantId == btn.getAttribute('data-variant')){
            btn.classList.add('disabled');

            // btn.textContent = 'Already in Cart'
          }
          if(newInfo&&oldInfo)oldInfo.innerHTML=newInfo.innerHTML;
          document.querySelectorAll('.wishlist-button-d5').forEach(button => {
              updateWishlistState(button);
            });
        });
      }
    }
  });


  document.body.addEventListener('click', async function (e) {
  const updateBtn = e.target.closest('#cart-drawer-d5 .mp-update-btn-d5');
  if (!updateBtn || updateBtn.classList.contains('disabled')) return;
  e.preventDefault();
  const newVariantId = updateBtn.getAttribute('data-variant');
  if (!oldVariantId || !newVariantId || oldVariantId === newVariantId) return;
  const modal = document.querySelector('.cd-variant-update-modal-d5');
  closeModal(select = '.cd-variant-update-modal-d5');
  drawer.classList.add('atc-loading-d5');
  setTimeout(() => {
     positionDrawer();
     drawer.classList.add('active');
  }, 200);
  const qty = oldVariantQuantity ? oldVariantQuantity : 1
  try {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: oldVariantId, quantity: 0 })
    });
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: newVariantId, quantity: qty })
    });
    await rerender();
    modal.classList.remove('active');
  } catch (error) {
    console.error('Error updating variant:', error);
  } finally {
    drawer.classList.remove('atc-loading-d5');
  }
  document.querySelectorAll('.wishlist-button-d5').forEach(button => {
    updateWishlistState(button);
  });
});

document.body.addEventListener('click', async function (e) {
  const link = e.target.closest('.mp-color-switch-link-d5');
  if (!link) return;
  e.preventDefault();
  const modal = link.closest('.cd-variant-update-modal-d5, .quick-add-modal-d5, .cart-add-modal-d5');
  if (!modal) return;
  const modalInner = modal.querySelector('.cdv-um-inner-d5, .qa-inner-d5');
  if (!modalInner) return;
  const url = link.dataset.url;
  try {
    const response = await fetch(url);
    const html = await response.text();
    const temp = document.createElement('div');
    temp.innerHTML = html;
    const mainProduct = temp.querySelector('.main-product-d5');
    if (mainProduct) {
      const oldMainProduct = modalInner.querySelector('.main-product-d5');
      if (oldMainProduct) oldMainProduct.remove();
      modalInner.appendChild(mainProduct);
    }
  } catch (error) {
    console.error('Error switching color:', error);
  }
  document.querySelectorAll('.wishlist-button-d5').forEach(button => {
    updateWishlistState(button);
  });
});

function closeModal(select) {
  const modal = document.querySelector(select);
  const appendedSection = modal.querySelector('.main-product-d5');
  if (appendedSection) appendedSection.remove();
  modal.classList.remove('active', 'loading-nul');
}

document.body.addEventListener("click", function (e) {
  if (e.target.hasAttribute('close-update-modal-d5')) {
    e.preventDefault();
    closeModal(select = '.cd-variant-update-modal-d5');
  }
  if (e.target.hasAttribute('qa-close-modal-d5')) {
    e.preventDefault();
    closeModal(select = '.qa-inner-d5');
    document.querySelector('.quick-add-modal-d5').classList.remove('active', 'loading-nul');
  }
});

document.querySelectorAll('[cn-close-d5]').forEach(btn => {
  btn.addEventListener('click', () => {
    document.querySelector('.cn-main-d5').classList.remove('active');
  })
})

document.addEventListener('click',async function(e){
  const el=e.target.closest('.cn-up-option-d5');
  const modal = document.querySelector('.quick-add-modal-d5');
  if(!el)return;
  e.preventDefault();
  const url=el.getAttribute('data-url');
  if(!url)return;
  // Opening a NEW product from an upsell card, not editing a variant
  // already in the cart - clear any stale edit-flow state so the shared
  // .mp-value-d5 handler below doesn't wrongly disable the Add button by
  // comparing against a leftover oldVariantId from a previous edit.
  oldVariantId = null;
  // BUG FIX: `.active` (which triggers the slide-up transition) used to be
  // added HERE, before the product content was fetched - so the sheet
  // slid up empty, and the real content only popped in afterward once the
  // fetch resolved, a moment later. That's the actual "bad animation" -
  // two separate visible steps (empty sheet slides in, THEN content
  // appears) instead of one clean reveal. Fetch and insert the content
  // FIRST, and only add `.active` once it's already in place, so the
  // sheet slides up already showing its final content, matching Fashion
  // Nova's real behavior.
  try{
    const response=await fetch(url);
    if(!response.ok)throw new Error();
    const htmlText=await response.text();
    const parser=new DOMParser();
    const doc=parser.parseFromString(htmlText,'text/html');
    const productContent=doc.querySelector('.main-product-d5');
    if(!productContent)return;
    const targetContainer=document.querySelector('.qa-inner-d5');
    if(!targetContainer)return;
    const oldProductContent=targetContainer.querySelector('.main-product-d5');
    if(oldProductContent)oldProductContent.remove();
    targetContainer.appendChild(productContent);
    modal.classList.add('loading-nul');
    // This modal markup is shared with the "edit style of an item already
    // in the cart" flow (where "Edit Style"/"Update item" is correct) -
    // relabel it for the "add a new product" context to match Fashion
    // Nova's real "Quick Add" wording. The header lives outside
    // .mp-product-info-d5, so it survives later color/size-switch
    // re-renders inside this modal untouched.
    const headerEl = productContent.querySelector('.mp-header-d5 p');
    if (headerEl) headerEl.textContent = 'Quick Add';
    modal.classList.add('active');
  }catch(err){
    console.error(err);
  }
  document.querySelectorAll('.wishlist-button-d5').forEach(button => {
    updateWishlistState(button);
  });
});

// Toggle the "Product Details" accordion inside the Quick Add / Edit Style
// modal. The real product page (sections/custom-main-product.liquid) binds
// this same [data-testid="accordion-container"] markup with a plain
// querySelectorAll(...).forEach(...) at page load, which only ever sees
// accordions that already exist in the initial page HTML - it can't see
// this modal's copy, since that's injected later via AJAX. Using event
// delegation here instead means it works no matter when the accordion
// enters the DOM.
document.body.addEventListener('click', function (e) {
  const container = e.target.closest('[data-testid="accordion-container"]');
  if (!container) return;
  // The footer's mobile Get Help / Company / Quick Links accordions reuse
  // this same data-testid naming (copied from the same reference markup)
  // but already have their own working inline onclick handler. Without this
  // guard, this global delegated listener ALSO fired for them and re-read
  // data-expanded right after the footer's own handler had just flipped it
  // open, so it immediately toggled it closed again in the same click -
  // the footer accordion looked broken (aria-expanded flipped to true, but
  // the panel never visibly opened) even though its own handler was correct.
  if (container.closest('footer')) return;
  const wrapper = container.closest('[data-testid="accordion-wrapper"]');
  if (!wrapper) return;
  const childContainer = wrapper.querySelector('[data-testid="accordion-children-container"]');
  const arrow = wrapper.querySelector('.arrow');
  const expanded = childContainer.getAttribute('data-expanded') === 'true';
  if (expanded) {
    childContainer.style.maxHeight = '0px';
    if (arrow) arrow.style.transform = 'rotate(270deg)';
    childContainer.setAttribute('data-expanded', 'false');
  } else {
    childContainer.style.maxHeight = childContainer.scrollHeight + 'px';
    if (arrow) arrow.style.transform = 'rotate(90deg)';
    childContainer.setAttribute('data-expanded', 'true');
  }
});

// Actually add the selected variant to the cart from the Quick Add modal
// (opened via .cn-up-option-d5 above) - this button previously had no
// handler at all in this context (only '#cart-drawer-d5 .mp-update-btn-d5'
// existed, which never matches here since .quick-add-modal-d5 isn't inside
// #cart-drawer-d5), so clicking "Add to cart" silently did nothing.
document.body.addEventListener('click', async function (e) {
  const btn = e.target.closest('.quick-add-modal-d5 .mp-update-btn-d5');
  if (!btn || btn.classList.contains('disabled')) return;
  e.preventDefault();
  const variantId = btn.getAttribute('data-variant');
  if (!variantId) return;
  btn.classList.add('disabled');
  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    });
    if (!res.ok) throw new Error('Unable to add to cart');
    await rerender();
    closeModal('.qa-inner-d5');
    document.querySelector('.quick-add-modal-d5').classList.remove('active', 'loading-nul');
  } catch (error) {
    console.error('Error adding to cart:', error);
  } finally {
    btn.classList.remove('disabled');
  }
});

document.body.addEventListener('click', async function (e) {
  // :not(.mp-update-btn-d5) excludes the Quick Add modal's own Add button
  // (handled separately above) - both share the .atc-btn-d5 class and both
  // sit inside #cart-notification-d5, so without this exclusion a click on
  // the modal's button would ALSO match here, double-adding the item and
  // force-navigating to /cart mid-modal.
  const button = e.target.closest('#cart-notification-d5 .atc-btn-d5:not(.mp-update-btn-d5)');
  if (!button || window.innerWidth >= 750) return;
  const variantId = button.getAttribute('data-variant');
  const formData = new FormData();
  formData.append('id', variantId);
  formData.append('quantity', 1);
  try {
    await fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
    });
    window.location.href = '/cart';
  } catch (err) {
    console.error(err);
  }
});


})();
